import { forwardRef, HTMLAttributes } from "react";

import { cn } from "@/utils/cn";

const CellWrapper = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(({ children, className, ...props }, ref) => (
  <div ref={ref} className={cn("flex items-center justify-between gap-2 rounded-medium bg-content2 p-4", className)} {...props}>
    {children}
  </div>
));

CellWrapper.displayName = "CellWrapper";

export default CellWrapper;
